import { useContext } from 'react';
import UserContext from '../../pages/layout/UserContext';
import checkPermission from './Util';

export function hasWritePermission(asset) {
  let currentUser = useContext(UserContext);
  return checkPermission(currentUser, asset, "write");
}
